import { useEffect, useState } from 'react';

/* Theme colors: canvas charts and SVG map markers bake colors into their
 * markup, so they read the design tokens (which the .dark-mode class on
 * <html> swaps) instead of hard-coding light-mode values. */

export function themeColor(name, fallback) {
  if (typeof window === 'undefined' || !window.getComputedStyle) return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name);
  return value && value.trim() ? value.trim() : fallback;
}

export function withAlpha(color, alpha) {
  const hex = String(color).match(/^#([0-9a-f]{6})$/i);
  if (!hex) return color;
  const n = parseInt(hex[1], 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}

// Re-renders subscribers when the user toggles dark mode on <html>.
export function useThemeMode() {
  const [dark, setDark] = useState(
    () =>
      typeof document !== 'undefined' && document.documentElement.classList.contains('dark-mode')
  );
  useEffect(() => {
    const sync = () => setDark(document.documentElement.classList.contains('dark-mode'));
    const observer = new MutationObserver(sync);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);
  return dark;
}
